const initialState = {
  PopUpShowSuccess: false,

  successMsg: ""
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SUCCESS_POPUP":
      return {
        ...state,
        PopUpShowSuccess: action.payload
      };

    case "SET_SUCCESS_MESSAGE":
      console.log("reducermsg", action.payload);
      return {
        ...state,
        successMsg: action.payload
      };

    default:
      return state;
  }
};
export default reducer;
